import type {OrderFormState} from '../../../types'

export const LAYOUT_STORAGE_KEY = '__ya_delivery_order_form_layout'

export function getLayoutFromStorage() {
  const data = window.localStorage.getItem(LAYOUT_STORAGE_KEY)
  return data ? JSON.parse(data) : undefined
}
export function setLayoutToStorage(layout: OrderFormState) {
  window.localStorage.setItem(LAYOUT_STORAGE_KEY, JSON.stringify(layout))
}
